export const KYC_QUESTION_TYPE = {
    SINGLE: 'single',
    MULTI: 'multi',
    FREETEXT: 'freetext'
};
